import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { isFetchBaseQueryError } from 'lib-shared-auth';
import { Channel } from 'lib-shared-types-channels';

type DetailedError = FetchBaseQueryError & {
  data: {
    detail: string;
  };
};

/** Represents the available features for an AI writing style guide. */
export type AiStyleGuideFeatures = 'impr_reply';

/** Represents an AI style guide. */
export type AiStyleGuide = {
  readonly contexts: {
    readonly channels: Channel[];
    readonly features: AiStyleGuideFeatures[];
  };
  /** The date at which the writing style guide was created */
  readonly created_at: string;
  /** The id of the writing style guide */
  readonly id: string;
  /** Content provided to the style guide */
  readonly content: string;
  /** The name of the style guide. */
  readonly name: string;
};

export type AiStyleGuideChannelContext = `channel:${Channel}`;
export type AiStyleGuideFeatureContext = `feature:${string}`;

/**
 * Type predicate to narrow an unknown error to an object with the property
 * 'data' containing a string 'detail' property
 */
export const isDetailedError = (error: unknown): error is DetailedError => {
  if (isFetchBaseQueryError(error)) {
    const errorData = (error as DetailedError).data;
    return (
      typeof errorData === 'object' &&
      errorData != null &&
      'detail' in errorData &&
      typeof errorData.detail === 'string'
    );
  }
  return false;
};
